// importing templates
import tasksGroupContainerTemplate from './tasks.group.container.html';
import tasksFeedTemplate from '../tasks-feed/tasks.feed.html';

const module = angular.module('websked.task.groups', []);

function taskGroupsRoutes($stateProvider) {
  $stateProvider
    .state('tasks.groups', {
      abstract: true,
      url: '/groups',
      template: tasksGroupContainerTemplate
    })
    .state('tasks.groups.group', {
      url: '/:id?ts',
      params: {
        ts: {
          array: true
        }
      },
      controller: 'TasksFeedController',
      template: tasksFeedTemplate,
      resolve: {
        entity: [
          '$stateParams',
          $stateParams => ({ type: 'group', id: $stateParams.id })
        ]
      },
      data: {
        pageTitle: {
          de: 'Gruppenaufgaben',
          en: 'Group Tasks',
          es: 'Tareas de Grupo',
          fr: 'Tâches de Groupe'
        }
      }
    });
}

module.config(['$stateProvider', taskGroupsRoutes]);
